<template>
    <span class="fileList__list--cad">
        <div v-for="document in documents">
            <h3>{{document.label}}</h3>
            <a class="downloadFile downloadFile--single" :href="link.link" target="_blank"
               v-for="link in document.links">{{link.name}}</a>

            <a
              v-if="document.profiLink"
              class="downloadFile downloadFile--single"
              :href="document.profiLink"
              target="_blank"
            >
              Související informace k detailu
            </a>
        </div>
    </span>
</template>

<script>
    export default {
        name: 'CadConstructionList',
        props: {
            documents: {
                type: Array,
                default: [],
            },
            type: {
                type: String,
                default: null,
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/cad/ConstructionList.vue